module.exports = __webpack_public_path__ + "static/media/pro.66c23be6.png";